import React from "react";
import TransactionsBaseComponent from "../bases/TransactionsBaseComponent/TransactionsBaseComponent"
export default function TransactionsPage() { return <TransactionsBaseComponent />; }
